<app-lex-xi-modal
  [isVisible]="isVisible"
  [canBackdropClose]="false"
  maxWidth="80vw"
  max-height="80vh"
  (close)="onClose()"
>
  <ng-template appXIModalContent>
    <ng-container *transloco="let t; prefix: 'widgets.ai-insights.insight-card'">
      <div class="insight-card__header">
        <div class="insight-card__header-title">{{ t('insights') }}</div>
        @if (canUpdateInsights) {
          <div>
            <xi-icon-button
              icon="edit"
              color="CX"
              class="insight-card__header-edit"
              (onClick)="onEditClicked()"
            ></xi-icon-button>
          </div>
        }
      </div>

      <div class="insight-card__body">
        <ng-container *ngTemplateOutlet="bodyTemplate; context: { isModal: true }"> </ng-container>

        <div class="insight-card__section">
          <div class="insight-card__section-image">
            @if (isImageLoading) {
              <div class="xi-loader-container__inline-overlay">
                <xi-animation
                  [height]="75"
                  [width]="75"
                  [loop]="true"
                  animation="cx_loader"
                ></xi-animation>
              </div>
            } @else if (imageExists) {
              <div class="insight-card__image">
                <img [src]="insightImage" [alt]="t('chart-image')" />
              </div>
            }
          </div>

          <div>
            @if (insightCardModel.tags.length) {
              <div class="insight-card__section-title">{{ t('tags') }}</div>
              <div class="insight-card__tag-pills">
                @for (tag of insightCardModel.tags; track tag) {
                  <span class="insight-card__tag-pill">{{ tag }}</span>
                }
              </div>
            }

            @if (insight.comment) {
              <div class="insight-card__comment">
                <div class="insight-card__section-title">{{ t('comments') }}</div>
                <span class="insight-card__section-subtext">{{ insightCardModel.comments }} </span>
                @if (publishedAt) {
                  <div class="insight-card__comment-meta">
                    {{ publishedAt | date: 'MMMM dd, yyyy HH:mm' }}
                    @if (publisherDisplayName) {
                      | {{ publisherDisplayName }}
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>
</app-lex-xi-modal>
